module.exports = __webpack_public_path__ + "img/API Documentation.1a67f495.svg";